
import { Component, Vue} from 'vue-property-decorator';
import Tooltip from "@/components/survey/Tooltip.vue"

@Component({
    components:{
        Tooltip
    }
})
export default class terms extends Vue {

	public navigate() {
        
        this.$router.push({ name: "applicant-status" });
         
    }

    public openQualify() {
        
        this.$router.push({ name: "pre-qualification" });
         
    }

  
};
